import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService, ModalService } from '@lib/services';
import {
  baggageApplicationModalPayloadParts,
  loungeApplicationModalPayloadParts,
  mealApplicationModalPayloadParts,
} from '@app/id-modal/service-application';
import { CurrentCartStoreService } from '@common/services';
import { getLoungeTestData } from '@app/test-ssn/testData/services-application/loungeApplicationModalTest';
import { deepCopy } from '@common/helper/deep-copy';
import { getBaggageTestData } from '@app/test-ssn/testData/services-application/baggageApplicationModalTestData';
import { getMealTestData } from '@app/test-ssn/testData/services-application/mealApplicationModalTestData';

@Component({
  selector: 'asw-services-application-test',
  templateUrl: './services-application-test.html',
  styleUrls: ['../../test-ssn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceApplicationTestComponent extends SupportComponent {
  constructor(
    private common: CommonLibService,
    private _changeDetector: ChangeDetectorRef,
    private _currentCartService: CurrentCartStoreService,
    private modal: ModalService
  ) {
    super(common);
  }

  reload(): void {}
  init(): void {}
  destroy(): void {}

  serviceApplication(num: number) {
    //const master = JSON.parse(JSON.stringify(this._currentCartService.CurrentCartData));

    const master = deepCopy(this._currentCartService.CurrentCartData);
    console.log(master, this._currentCartService.CurrentCartData);
    //console.log(master,this._currentCartService.CurrentCartData)
    ///*
    if (!master.data) master.data = {};
    if (!master.data.plan) master.data.plan = {};
    if (!master.data.plan.services) master.data.plan.services = {};
    if (!master.data.plan.airOffer) master.data.plan.airOffer = {};
    if (!master.data.plan.airOffer.bounds) master.data.plan.airOffer.bounds = [];
    if (!master.data.plan.travelers) master.data.plan.travelers = [];

    switch (num) {
      case 0:
        const update = getLoungeTestData(master);
        console.log(update);
        this._currentCartService.setCurrentCart(update);
        const part1 = loungeApplicationModalPayloadParts();
        this.modal.showSubPageModal(part1);
        break;
      case 1:
        const updateBaggage = getBaggageTestData(master);
        this._currentCartService.setCurrentCart(updateBaggage);
        console.log(updateBaggage);
        const part2 = baggageApplicationModalPayloadParts();
        this.modal.showSubPageModal(part2);
        break;
      case 2:
        const updateMeal = getMealTestData(master);
        this._currentCartService.setCurrentCart(updateMeal);
        console.log(updateMeal);
        const part3 = mealApplicationModalPayloadParts();
        this.modal.showSubPageModal(part3);
        break;
    }
    //*/
  }
}
